import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import ApiService from 'src/services/ApiService';
import { isChecklistSyncInFlight } from 'src/services/checklist/syncTypes';

const syncStatusKey = (
  checklistId: string,
): ['/tenant/checklist/sync-status', string] => [
  '/tenant/checklist/sync-status',
  checklistId,
];

/**
 * Latest sync job for a checklist. The sync runs asynchronously on the server,
 * so this polls while a job is in flight and goes quiet once it settles.
 */
export const useChecklistSyncStatus = (checklistId: string, enabled = true) => {
  return useQuery({
    queryKey: syncStatusKey(checklistId),
    queryFn: ApiService.checklist.getChecklistSyncStatus,
    enabled: enabled && !!checklistId,
    refetchInterval: (query) =>
      isChecklistSyncInFlight(query.state.data) ? 3000 : false,
  });
};

export const useSyncTenantChecklistMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['/tenant/checklist/sync' as const],
    mutationFn: ApiService.checklist.syncTenantChecklist,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: syncStatusKey(variables.checklistId),
      });
    },
  });
};
